import styled from 'styled-components';
import { Icon } from '@perch-labs/shrike';

export const StyledIcon = styled(Icon)`
  transform: translateY(-3px);
`;
